angular.module('admin.subscriptions')
    .controller('SubscriptionRevenuesCtrl', function ($uibModal, SubscriptionRevenueResource) {

        this.filter = {
            page: 1,
            pageSize: 20,
            sortDir: 'descending'
        };

        this.paginate = function () {
            SubscriptionRevenueResource.query(this.filter, (data) => {
                this.revenues = data;
            });
        }
        this.search = function () {
            this.filter.page = 1;
            this.paginate();
        }

        this.search();


        this.create = function () {
            $uibModal.open({
                controller: 'SubscriptionRevenuesEditCtrl',
                controllerAs: 'ctrl',
                templateUrl: 'views/subscriptions/edit_revenue.html',
                resolve: {
                    item: () => null
                }
            }).result.then(() => this.search());
        }

        this.edit = function (item) {

            $uibModal.open({
                controller: 'SubscriptionRevenuesEditCtrl',
                controllerAs: 'ctrl',
                templateUrl: 'views/subscriptions/edit_revenue.html',
                resolve: {
                    item: () => item
                }
            }).result.then(() => this.search());
        };

        this.remove = function (item) {
            $uibModal.open({
                controller: function($uibModalInstance) {
                    this.no = () => {
                        $uibModalInstance.dismiss();
                    }
                    this.yes = () => {
                        SubscriptionRevenueResource.remove({
                            id: item.id
                        }, () => {
                            $uibModalInstance.close();
                        });
                    }
                },
                controllerAs: 'ctrl',
                templateUrl: 'views/subscriptions/delete_revenue.html'
            }).result.then(() => this.paginate());
        }

    }).controller('SubscriptionRevenuesEditCtrl', function (
        $uibModalInstance,
        SubscriptionRevenueResource,
        vindiPaymentTypes,
        item) {
        if (item) {
            this.item = new SubscriptionRevenueResource(item);
            this.item.paidAt = new Date(this.item.paidAt);
        } else {
            this.item = new SubscriptionRevenueResource({
                paymentMethod: 'deposit'
            });
        }

        this.methods = vindiPaymentTypes;

        this.dismiss = function () {
            $uibModalInstance.dismiss();
        }
        this.save = function () {
            this.item.$save(() => $uibModalInstance.close());
        }
    })
    .config(($stateProvider) => {
        $stateProvider.state('admin.revenues', {
            controller: 'SubscriptionRevenuesCtrl',
            controllerAs: 'ctrl',
            templateUrl: 'views/subscriptions/revenues.html',
            url: 'subscription_revenues'
        });
    });